<template>
  <div class="prizes-info" :style="{order:h5ConfigDetails[0]['modalOrder']['PrizesInfoOrder'][0]}">
    <vue-seamless-scroll
      :data="evil(h5ConfigDetails[0]['prizesInfoConfig']['prizesRecord'][0])"
      :class-option="seamlessScrollOption"
      class="prize-info"
    >
      <ul>
        <li
          v-for="(item, index) in evil(h5ConfigDetails[0]['prizesInfoConfig']['prizesRecord'][0])"
          :key="index"
        >
        <span>{{ item.name }}</span>&nbsp;&nbsp;&nbsp;&nbsp;获得了<span>{{ item.prize | transformat }}</span>
        </li>
      </ul>
    </vue-seamless-scroll>
    <img class="bg" :src="`${baseUrl.portalImg}${h5ConfigImgPath}/${h5ConfigDetails[0]['prizesInfoImg']['prizesInfoBg'][0]}`" alt="">
  </div>
</template>

<script>
import { mapState } from 'vuex'
import { baseUrl } from '@/config/env'
import VueSeamlessScroll from 'vue-seamless-scroll'

export default {
  name: 'PrizesInfo',
  data () {
    return {
      baseUrl,
    }
  },
  components: {
    VueSeamlessScroll
  },
  computed: {
    ...mapState(['h5ConfigDetails', 'h5ConfigImgPath']),
    seamlessScrollOption () {
      return {
        step: 0.2, // 数值越大速度滚动越快
        limitMoveNum: 6, // 开始无缝滚动的数据量 this.dataList.length
        hoverStop: false, // 是否开启鼠标悬停stop
        direction: 1, // 0向下 1向上 2向左 3向右
        openWatch: true, // 开启数据实时监控刷新dom
        singleHeight: 0, // 单步运动停止的高度(默认值0是无缝不停止的滚动) direction => 0/1
        singleWidth: 0, // 单步运动停止的宽度(默认值0是无缝不停止的滚动) direction => 2/3
        waitTime: 1000, // 单步运动停止的时间(默认值1000ms)
        openTouch: false, // 移动端是否开启touch滑动
        switchDelay: 1000
      }
    }
  },
  filters: {
    transformat (value) {
      if (value.length > 9) {
        return value.slice(0, 9) + '…'
      }
      return value
    }
  },
  created () {
  },
  mounted () {
  },
  methods: {
    evil (fn) { // 处理服务端返回字符串类型数据
      let Fn = Function // 一个变量指向Function，防止有些前端编译工具报错
      return new Fn('return ' + fn)()
    }
  }
}
</script>

<style scoped lang="less">
  .prizes-info{
    position: relative;
    font-size: 0;
    .bg{
      width: 100%;
      height: auto;
      display: block;
    }

    .prize-info {
      width: 20.7rem;
      height: 2.1rem;
      font-size: 0.93rem;
      font-family: PingFangSC-Medium, PingFang SC;
      font-weight: bold;
      color: #FFFFFF;
      line-height: 2.8rem;
      position: absolute;
      bottom: 1.3rem;
      margin: auto;
      left: 0;
      right: 0;
      overflow: hidden;
      // background: linear-gradient(180deg, #FFEEB8 0%, rgba(255,221,200,0.62) 100%);
      border-radius: 1.2rem;
      background-repeat: no-repeat;
      background-size: 100%;
      text-align: center;
      &>li {
        height: 2.7rem;
        line-height: 2.7rem;
        text-align: center;
        color: #fff;;
        font-size:1rem;
        font-family: PingFangSC-Regular, PingFang SC;
        transform: scale(0.9);
      }
    }
  }
</style>